import React, { Component } from 'react';
import constants from 'js/modules/constants';
import moment from 'moment';
import validationEngine from 'js/modules/validationEngine';
import DataService from 'js/modules/dataservice';
import storage from 'js/modules/persist';
import gatracking from '../../modules/gatracking';

const VacationContext = React.createContext();

// const isSandals = window._app.brandOptions.isSandals;
// the code below is commented for the moment in case there is no use for it please remove it.
// const currentEnviroment = window._app.results.environment;
// const brandName = isSandals ? 'sandals' : 'beaches';
// const tstUrl = isSandals ? 'https://v13.sandals.com/my-account/' : 'https://v12.beaches.com/my-account/';
// const urlBase = currentEnviroment === 'TST' ? tstUrl : `https://${brandName}.com/my-account/`;

// Vacation
const validationRules = {
  username_recovery: [],
  email_recovery: ['email'],
  username: ['ssgUsername'],
  password: [],
  rstCode: ['required'],
  checkOutDate: ['required'],
  checkInDate: ['required'],
  adults: ['numeric'],
  children: ['numeric'],
  infants: ['numeric'],
  airIncluded: [],
  promoCode: ['promoCode'],
  groupCode: ['groupCode'],
  departure_airport: ['required', 'alphaNumeric'],
  arrivalGateway: ['alphaNumeric'],
  flight_type: ['required', 'name'],
  fname: ['alphaSpaces'],
  email: ['beEmail'],
  country: ['alphaNumeric'],
  recaptchaToken: [],
  wedding: [],
  adjoiningRoom: [],
  prn: [],
  prEmail: ['beEmail'],
  prPromoCode: [],
  roomCode: [],
  bypassActive: [],
  startFrom: []
};

class VacationProvider extends Component {
  constructor(props) {
    super(props);

    this.recaptchaRef = React.createRef();
    this.recoveryUserRecaptchaRef = React.createRef();
    this.recoveryPasswordRecaptchaRef = React.createRef();
  }

  state = {
    reopeningDates: [],
    resortGateways: [],
    fields: {
      rstCode: '',
      checkInDate: '',
      checkOutDate: '',
      adults: 2,
      children: 0,
      infants: 0,
      wedding: false,
      airIncluded: true,
      promoCode: '',
      groupCode: '',
      departure_airport: '',
      arrivalGateway: '',
      flight_type: 'economy',
      fname: '',
      email: '',
      country: '',
      adjoiningRoom: 'false',
      prn: '',
      prEmail: '',
      prPromoCode: '',
      roomCode: '',
      bypassActive: false,
      startFrom: ''
    },
    fieldValidations: {},
    guestCount: {
      adults: 2,
      children: 0,
      infants: 0,
    },
    guestIndex: 0,
    guestInfo: {
      adults: {},
      children: {},
      infants: {},
    },
    addGuestErrorDetails: {},
    maxOccupancy: 0,
    ssgCredentials: {
      username: '',
      password: '',
      recaptchaToken: '',
    },
    hasSSG: false,
    hasGroup: false,
    ssgResponse: {
      code: -1,
      content: {
        name: '',
        memberid: '',
        availablePoints: 0,
        discountAmmount: 0,
        data: {
          result: '',
        },
      },
    },
    recoverySSGCredentials: {
      username_recovery: '',
      email_recovery: '',
    },
    isPassword: false,
    recoverySSGResponse: {
      code: -1,
    },
    warning: false,
    showLoader: false,
    submitSSGAttemps: 0,
    recoveryUserSSGAttemps: 0,
    recoveryPasswordSSGAttemps: 0,
    showRecaptcha: false,
    showRecoveryUserRecaptcha: false,
    showRecoveryPasswordRecaptcha: false,
    recaptchaToken: '',
    vacationData: {},
    vacationResponse: {},
    loyaltyOffer: {},
    privatePromotion: {},
    isLoading: true,
    groupResponse: { code: -1 },
    promoCodeResponse: { code: -1 },
    group: null,
    hasQQParams: false,
    isModalOpen: {
      inclusions: false,
      forgotPassword: false,
      privacyPolicy: false,
      pointsOffer: false,
      bestPrice: false,
      reopening: false,
      resortPicker: false,
      airCreditPromotion: false,
    },
    showFlightWarning: false,
    disableFlights: false,
    tempAirIncluded: true,
    isGuestControlOpen: false,
    showLessThan3NightsWarning: false,
  };

  async componentDidMount() {

    const {
      sandalsAccountActive = true,
    } = await DataService.isAccountServicesActive();

    if (sandalsAccountActive) {
      const accountsResponse = await DataService.getPrimaryAccount();
      const accountPointsResponse = await DataService.getAccountPoints();

      if (
        accountsResponse.status === 200 &&
        accountPointsResponse.status === 200
      ) {
        const profilesData = accountsResponse.content;
        const responseData = profilesData.primary_member;
        const addressData = responseData.Address;
        const pointsData = accountPointsResponse.content;
        const formattedBirth = responseData.birth_date
          ? moment.utc(new Date(responseData.birth_date)).format('YYYY-MM-DD')
          : '';
        const accountDataRequired = {
          accountNumber: profilesData.account_number || '',
          title: responseData.title || '',
          gender: responseData.gender || '',
          firstName: responseData.first_name || '',
          lastName: responseData.last_name || '',
          dateOfBirth: formattedBirth || '',
          address1: addressData.address1 || '',
          address2: addressData.address2 || '',
          city: addressData.city || '',
          state: addressData.state || '',
          country: addressData.country_code || '',
          zipCode: addressData.zip_code || '',
          phoneNumber:
            responseData.mobile_phone_number ||
            responseData.landline_phone_number ||
            responseData.landline_phone_number2 ||
            '',
          tier: profilesData.member_level || '',
          email: responseData.email || '',
          points: pointsData.points_available || 0,
        };

        const sandalsAccountResponse = await DataService.setSandalsAccountCookie(
          accountDataRequired
        );

        console.log('Process Sandals Accounts:', sandalsAccountResponse.code);
      }
    }

    const summaryResponse = await DataService.readSummary();


    const ssgResponse = { ...this.state.ssgResponse };
    const paramNames = Object.keys(_app.urlparams);
    const params = {};
    let guestInfo = null;
    let hasQQParams = false;

    // params from QQ comming in Uppercase
    paramNames.map((name) => {
      params[`${name.toLowerCase()}`] = _app.urlparams[name] || '';
    });

    // To show announcement pop-up on load uncomment this.
    // if(summaryResponse.content) {
    //   !summaryResponse.content.announcementOpened && this.setState({ isModalOpen: { reopening: true }});
    // }

    if (summaryResponse.content.reopeningDates) {
      if (summaryResponse.content.reopeningDates.openingDates) {
        this.setState({
          reopeningDates: summaryResponse.content.reopeningDates.openingDates,
        });
      }
    }

    const bypassFormParam = _app.urlparams.BYPASSFORM || _app.urlparams.bypassform;
    const rstCodeParam = _app.urlparams.RST_CODE || _app.urlparams.rst_code;
    const startDateParam = _app.urlparams.STARTDATE || _app.urlparams.startdate;
    const endDateParam = _app.urlparams.DEPARTUREDATE || _app.urlparams.departuredate;
    const gatewayParam = _app.urlparams.ARRIVAL_GATEWAY || _app.urlparams.arrival_gateway;
    // const airIncludedParam = _app.urlparams.AIR_INCLUDED;
    let notHaveQQParams = true;

    if (rstCodeParam || startDateParam || endDateParam || gatewayParam) {
      notHaveQQParams = false;
    }

    // The filled fields have priority over the QQ parameters.
    if (
      summaryResponse.content.vacationData &&
      !bypassFormParam &&
      notHaveQQParams
    ) {
      const vacationData = summaryResponse.content.vacationData;
      const loyaltyOffer = summaryResponse.content.loyaltyOffer || {};
      const privatePromotion = summaryResponse.content.privatePromotion || {};
      const group = summaryResponse.content.group;

      if (summaryResponse.content.vacationData.guestInfo) {
        guestInfo = summaryResponse.content.vacationData.guestInfo;
      }

      group && this.setState({ hasGroup: true });

      this.setState({ vacationData, loyaltyOffer, privatePromotion, group });
      this._setPrepopulatedFields();
    } else {
      if (
        params.hasOwnProperty('noofchildren') ||
        params.hasOwnProperty('noofadults') ||
        params.hasOwnProperty('noofinfants')
      ) {
        hasQQParams = true;

        this.setState({ hasQQParams });
      }
      this._setDefaultValues(summaryResponse.content);
    }

    if (
      summaryResponse.content.ssgMember &&
      summaryResponse.content.ssgMember.ssgNumber
    ) {
      ssgResponse.code = 1;
      ssgResponse.content = summaryResponse.content.ssgMember;

      this.setState({ ssgResponse, hasSSG: true });
    }

    // build guestInfo object for addGuest Component.
    if (!window._app.brandOptions.isSandals && !hasQQParams) {
      this._setInitialGuestInfo(guestInfo);
    }

    this.setDefaultValuesValidation();

    // hasQQParams flag only needed when we are setting the QQ params.
    this.setState({ hasQQParams: false });
  }


  _setDefaultDates = () => {
    const fields = { ...this.state.fields };
    const tomorrow = moment()
      .add(1, 'days')
      .format('YYYY-MM-DD');
    const oneWeek = moment()
      .add(8, 'days')
      .format('YYYY-MM-DD');

    fields.checkInDate = tomorrow;
    fields.checkOutDate = oneWeek;

    this.setState({ fields });
  };

  _setPrepopulatedFields = () => {
    const fields = { ...this.state.fields };
    const vacationData = { ...this.state.vacationData };
    const promoCodeResponse = { ...this.state.promoCodeResponse };
    const loyaltyOffer = { ...this.state.loyaltyOffer };
    const privatePromotion = { ...this.state.privatePromotion };
    const fieldNames = Object.keys(fields);

    let showFlightWarning = false;
    let showGuestsWarning = false;
    let disableFlights = false;
    let tempAirIncluded = true;

    fieldNames.map((field) => {
      if (vacationData[field] || field === 'airIncluded') {
        fields[field] = vacationData[field];
      } else if (field === 'departure_airport') {
        fields[field] = vacationData.departureFrom;
      } else if (field === 'flight_type') {
        fields[field] = vacationData.filterBy;
      }
    });

    showFlightWarning = this.checkAirAvailability({
      startDate: moment(fields.checkInDate, constants.DB_DATE_FORMAT),
      endDate: moment(fields.checkOutDate, constants.DB_DATE_FORMAT),
    });

    showGuestsWarning = this.checkGuestsAvailability(fields);
    if (showGuestsWarning) {
      disableFlights = true;
    }

    if (!showGuestsWarning && !fields.airIncluded) {
      tempAirIncluded = false;
    }

    if (showFlightWarning || showGuestsWarning) {
      fields.airIncluded = false;
      validationRules.departure_airport = ['alphaNumeric'];
    }

    if (!fields.airIncluded) {
      validationRules.departure_airport = ['alphaNumeric'];
      validationRules.flight_type = ['name'];
    }

    // Promo Validations
    if (loyaltyOffer && loyaltyOffer.offerCode) {
      fields.promoCode = loyaltyOffer.offerCode;
    }

    if (privatePromotion && privatePromotion.code) {
      fields.prPromoCode = privatePromotion.code;
    }

    if (fields.promoCode !== '') {
      promoCodeResponse.code = 1;
    }

    this.setState({
      fields,
      showFlightWarning,
      showGuestsWarning,
      disableFlights,
      isLoading: false,
      promoCodeResponse,
      tempAirIncluded,
    });
  };

  checkGuestsAvailability = (fields) => {
    const { adults, children, infants } = fields;

    const totalGuests = adults + children + infants;

    if (totalGuests > 8) {
      return true;
    }

    return false;
  };

  _setDefaultValues = async(content) => {
    const fields = { ...this.state.fields };
    const paramNames = Object.keys(_app.urlparams);
    const resortsGateways = await DataService.readResortGateways();
    const params = {};
    let showGuestsWarning = false;
    const brandNumberOfChildren = 0;
    let brandNumberOfAdults = 2;
    const brandNumberOfInfants = 0;

    // params from QQ comming in Uppercase
    paramNames.map((name) => {
      params[`${name.toLowerCase()}`] = _app.urlparams[name];
    });

    /* eslint-disable camelcase */
    const {
      arrival_gateway = '',
      noofadults = '',
      startdate = '',
      departuredate = '',
      noofchildren = '',
      rst_code = '',
      bypassform = '0',
      prn = '',
      premail = '',
      prpromocode = '',
      utm_source = '',
      seattype = '',
      cat_code = '',
      noofinfant = '',
      departure_from = '',
      ireferrer = '',
      childrenages = '',
      infantsbirthdays = '',
      arrivaldate = '',
      start_from = '',
    } = params;

    /* NOTES:
      The param names ​​of the websites are different from those required by the end point,
      I tried to change that but my request was rejected 😡
    */

    fields.checkInDate =
      startdate === '' ? '' : moment(startdate).format('YYYY-MM-DD');
    fields.checkOutDate =
      departuredate === '' ? '' : moment(departuredate).format('YYYY-MM-DD');
    fields.startFrom = start_from === '' ? '' : moment(start_from).format('YYYY-MM-DD');

    fields.rstCode = rst_code;
    fields.departure_airport = departure_from.toLowerCase();
    fields.prn = prn.trim() || '';
    fields.prEmail = premail.trim() || '';
    fields.prPromoCode =
      prpromocode.toUpperCase() === 'LTT005D' ? prpromocode.toUpperCase() : '';
    fields.roomCode = cat_code;
    const tempArrival = this.getArrivalAirport(
      rst_code.toLowerCase(),
      resortsGateways.content
    );

    gatracking.createStep1DataLayer(fields.rstCode, fields.checkInDate, fields.checkOutDate);

    if (arrival_gateway === '') {
      if (tempArrival.length > 0) {
        fields.arrivalGateway = tempArrival[0].value.toLowerCase(); // this add a airport to the arrival gateway comming from sandals or beaches
      }
    } else if (arrival_gateway !== '') {
      fields.arrivalGateway = arrival_gateway.toLowerCase();
    }

    /* SANITAZE URL PARAMS */
    if (
      fields.checkInDate === 'Invalid date' ||
      fields.checkOutDate === 'Invalid date'
    ) {
      fields.checkInDate = '';
      fields.checkOutDate = '';
    }

    if (window._app.brandOptions.isSandals) {
      brandNumberOfAdults = 2;
    }

    /* VALIDATING QQ PARAMS*/
    if (noofadults === '' || noofadults === '0' || fields.rstCode === '') {
      fields.adults = brandNumberOfAdults;
    } else if (!window._app.brandOptions.isSandals) {
      fields.adults = parseInt(noofadults, 10);
    }

    // modified children value for each brand except sandals
    if (noofchildren === '' || fields.rstCode === '') {
      fields.children = brandNumberOfChildren;
    } else if (!window._app.brandOptions.isSandals) {
      fields.children = parseInt(noofchildren, 10);
    }

    if (noofinfant === '' || fields.rstCode === '') {
      fields.infants = brandNumberOfInfants;
    } else if (!window._app.brandOptions.isSandals) {
      fields.infants = parseInt(noofinfant, 10);
    }

    // adults comming with "NO" value from other websites
    if (isNaN(params.noofadults)) {
      fields.adults = 2;
    }

    // childrens comming with "NO" value from other websites
    if (isNaN(params.noofchildren)) {
      fields.children = 0;
    }

    // infants comming with "NO" value from other websites
    if (isNaN(params.noofinfant)) {
      fields.infants = 0;
    }

    const childrenAgesArray = childrenages ? childrenages.split(',') : [];
    const infantsBirthdaysArray = infantsbirthdays ? infantsbirthdays.split(',') : [];
    const newInfantBirthdays = [];

    for (let x = 0; x < fields.infants; x++) {
      const isAnInfant = this._isAnInfant(infantsBirthdaysArray[x], fields.checkOutDate);

      if(!isAnInfant.infant) {
        childrenAgesArray.push(isAnInfant.age);
      } else {
        newInfantBirthdays.push(infantsBirthdaysArray[x]);
      }
    }

    fields.infants = newInfantBirthdays.length;
    fields.children = childrenAgesArray.length;

    this._buidGuestInfo(
      fields.rstCode,
      fields.adults,
      fields.children,
      fields.infants,
      childrenAgesArray,
      newInfantBirthdays
    );

    const showFlightWarning = this.checkAirAvailability({
      startDate: moment(fields.checkInDate),
      endDate: moment(fields.checkOutDate),
    });

    // validation for business rule, guests <= 8 with air
    showGuestsWarning = this.checkGuestsAvailability(fields);
    if (showFlightWarning || showGuestsWarning) {
      fields.airIncluded = false;
      validationRules.departure_airport = ['alphaNumeric'];
    }

    /* 
      * bypassUsed is the key to redirect back to the website, this variable is set on DataService.updateBypassUse() function
      * this only change when the bypass successfully go to a next step.
      * this variable is manipulate in the BE side.
    */
    const { bypassUsed = true } = content;

    // validation and process for user comming from tripAdvisor
    if(!bypassUsed && bypassform === '1') {
      const isBeaches = window._app.brandOptions.isBeaches;
      const currentEnviroment = window._app.results.environment;

      // bypass 1 redirections for beaches website
      if(isBeaches) {
        let base = 'beaches.com';

        if(currentEnviroment === 'PRD') {
          base = 'beaches.com/v2';
        }else if(currentEnviroment === 'STG') {
          base = 'v13.beaches.com';
        }else {
          base = 'beaches.dev.k8s.sandals.com/v2';
        }

        window.location.href = `https://${base}`;

        return;
      }

      window.location.href = 'https://sandals.com/';

      return;

    }

    if (
      bypassform === '1' &&
      startdate !== '' &&
      departuredate !== '' &&
      rst_code !== '' &&
      noofadults !== ''
    ) {
      if(departure_from !== '') {
        fields.airIncluded = true;
      }

      if (departure_from === '') {
        fields.airIncluded = false;
        validationRules.departure_airport = ['alphaNumeric'];
      }

      if (seattype === 'business') {
        fields.flight_type = 'business';
      }
      fields.bypassActive = true;

      /** 14 days restriction logic */
      if(fields.airIncluded) {
        const minFlightDate = moment().add(14, 'days');
        const startDate = moment(startdate, constants.DB_DATE_FORMAT);
        const validDate = startDate > minFlightDate;

        fields.airIncluded = validDate;
      }
      /** *************************** */

      if (this._IsResortAvailable(fields)) {
        this._jumpToAnotherStep(fields, this.state.guestInfo, bypassform, ireferrer);
      }
    }

    if(!bypassUsed && bypassform === '2') {
      const resorts = [
        {resort: 'BNG', resortURI: '/resorts/negril/'},
        {resort: 'BBO', resortURI: '/resorts/ocho-rios/'},
        {resort: 'BTC', resortURI: '/resorts/turks-caicos/'}
      ];
      const isBeaches = window._app.brandOptions.isBeaches;
      const currentEnviroment = window._app.results.environment;


      const selectedResort = resorts.find((resort) => {
        return resort.resort === rst_code.toUpperCase();
      });


      const url = selectedResort && selectedResort.resortURI;

      // bypass 2 redirecctions for beaches website
      if(isBeaches) {
        let base = 'beaches.com';

        if(currentEnviroment === 'PRD') {
          base = 'beaches.com/v2';
        }else if(currentEnviroment === 'STG') {
          base = 'v13.beaches.com';
        }else {
          base = 'beaches.dev.k8s.sandals.com/v2';
        }

        window.location.href = `https://${base}${url}rooms-suites/detail/?categoryCode=${cat_code}`;
      } else {
        let base = 'sandals.com';

        if(currentEnviroment === 'PRD') {
          base = 'sandals.com';
        }else if(currentEnviroment === 'STG') {
          base = 'stg.sandals.com';
        }else {
          base = 'v13.sandals.com';
        }

        const sandalsResorts = window._app.results.resorts;
        const resortSelected = sandalsResorts.find((resort) => resort.rstCode === rst_code.toUpperCase());
        const newURL = resortSelected && resortSelected.resortURI;

        window.location.href = `https://${base}${newURL}rooms-suites/detail/?categoryCode=${cat_code}&ARRIVALDATE=${arrivaldate}&DEPARTUREDATE=${departuredate}`;
      }

      return;
    }

    // coming from flexible dates
    if (
      bypassform === '2' &&
      startdate !== '' &&
      departuredate !== '' &&
      rst_code !== '' &&
      noofadults !== '' &&
      this._IsResortAvailable(fields)
    ) {
      if (departure_from === '') {
        fields.airIncluded = false;
        validationRules.departure_airport = ['alphaNumeric'];
      }

      if (seattype === 'business') {
        fields.flight_type = 'business';
      }
      fields.bypassActive = true;

      /** 14 days restriction logic */
      let checkAirIncluded = departure_from !== '';

      if(checkAirIncluded) {
        const minFlightDate = moment().add(14, 'days');
        const startDate = moment(startdate, constants.DB_DATE_FORMAT);
        const validDate = startDate > minFlightDate;

        fields.airIncluded = validDate;
        checkAirIncluded = validDate;
      }

      this._jumpToAnotherStep(fields, this.state.guestInfo, bypassform, ireferrer, checkAirIncluded);
    }
    /** ************************* */

    if (utm_source === 'tripadvisor') {
      fields.airIncluded = false;
    }

    if (seattype === 'business') {
      fields.flight_type = 'business';
    }
    /* eslint-enable camelcase */
    /* END VALIDATIONS */

    this.setState({
      fields,
      showGuestsWarning,
      showFlightWarning,
      isLoading: false,
    });
  };

  _IsResortAvailable = (fields) => {
    const {
      checkInDate: rawCheckInDate,
      checkOutDate: rawCheckOutDate,
      rstCode,
    } = fields;
    const mCheckInDate = moment(rawCheckInDate);
    const mCheckOutDate = moment(rawCheckOutDate);
    const resortDatesFM = window._app.results.resortDates;

    if (resortDatesFM) {
      if (Object.keys(resortDatesFM).length > 0) {
        const resortDates = resortDatesFM[rstCode.toLowerCase()];

        if (mCheckInDate.isValid() && mCheckOutDate.isValid() && resortDates) {
          let isAvailable = true;

          resortDates.forEach((resortDays) => {
            const rangeStart = moment(resortDays.starDate);
            const rangeEnd = moment(resortDays.endDate);
            const diffWithRangeStart = mCheckInDate.diff(rangeStart, 'days');
            const diffWithEndStart = mCheckInDate.diff(rangeEnd, 'days');

            if (diffWithEndStart < 0 || diffWithRangeStart < 0) {
              isAvailable = false;
            }
          });

          return isAvailable;
        }
      }
    }

    return true;
  };

  _createURLParams = (params) => {
    const {
      ARRIVAL_GATEWAY = '',
      CAT_CODE = '',
      COOKIENAME = '',
      DEPARTUREDATE = '',
      DEPARTURE_FROM = '',
      EVENT = '',
      RST_CODE = '',
      SEATTYPE = '',
      STARTDATE = '',
      air_included = '',
      brand = '',
      childrenAges = '',
      // infantsBirthdays = '',
      ireferrer = '',
      noOfAdults = '',
      noOfChildren = '',
      // noOfInfant = ''
    } = params;

    const newURL = `CAT_CODE=${CAT_CODE}&RST_CODE=${RST_CODE}&DEPARTUREDATE=${DEPARTUREDATE}&COOKIENAME=${COOKIENAME}&noOfAdults=${noOfAdults}&noOfChildren=${noOfChildren}&air_included=${air_included}&ireferrer=${ireferrer}&EVENT=${EVENT}&SEATTYPE=${SEATTYPE}&STARTDATE=${STARTDATE}&DEPARTURE_FROM=${DEPARTURE_FROM}&childrenAges=${childrenAges}&ARRIVAL_GATEWAY=${ARRIVAL_GATEWAY}&brand=${brand}`;

    return newURL;
  }

  _jumpToAnotherStep = async(fields, guestInfo, bypass, ireferrer, checkAirIncluded = false) => {
    const step1 = await DataService.processVacation(fields, guestInfo);
    const urlParams = _app.urlparams;

    const params = this._createURLParams(urlParams);

    this.setVacationResponse(step1);

    await DataService.getRooms({ ...fields });

    if (bypass === '2') {
      const step2 = await DataService.processRoom(fields);

      if(step2.code === 1 && checkAirIncluded) {
        await DataService.updateBypassUse();

        window.location.href = `/itineraries/?subSessionId=${encodeURIComponent(
          window._app.page.subSessionId
        )}&ireferrer=${ireferrer}`;

        return;
      }
      if (step2.code === 1 && !checkAirIncluded) {
        await DataService.updateBypassUse();
        window.location.href = `/guests/?subSessionId=${encodeURIComponent(
          window._app.page.subSessionId
        )}&ireferrer=${ireferrer}`;

        return;
      }
    }

    if (step1.code === 1) {
      await DataService.updateBypassUse();
      window.location.href = `/room/?subSessionId=${encodeURIComponent(
        window._app.page.subSessionId
      )}&bypassForm=${bypass}`;

      return;
    }

    // this is only for the case of infants are more than the number of adults - is a air business rule only
    if(fields.airIncluded) {
      window.location.href = `/?subSessionId=${encodeURIComponent(
        window._app.page.subSessionId
      )}&${params}`;

      return;
    }
  };

  setVacationResponse = (response) => {
    this.setState({ vacationResponse: response });
  };

  cleanVacationResponse = () => {
    this.setState({ vacationResponse: {} });
  };

  _isAnInfant = (infantsBirthdays, checkOutDate) => {
    const infantDate = new Date(infantsBirthdays);
    const endDate = new Date(checkOutDate);

    const age = moment(endDate, 'YYYY-MM-DD').diff(moment(infantDate, 'YYYY-MM-DD'), 'year', true); // this is nasty I know
    const isInfant = age < 1.999;
    const roundedAge = isNaN(age.toFixed()) ? '' : age.toFixed();

    return {infant: isInfant, age: roundedAge};
  }

  _buidGuestInfo = (rstCode, adults, children, infants, childrenAges, infantsBirthdays) => {
    /* Build guestInfo oject for addGuests Component */
    const adultsObject = {};
    const childrenObject = {}; // needed
    const infantsObject = {}; // needed
    const guestInfo = {};

    // do not create structure if rstCode is not comming ***Business rule
    if (rstCode !== '') {
      for (let x = 0; x < adults; x++) {
        adultsObject[`age_guest_${x}`] = '18';
        adultsObject[`dob_guest_${x}`] = '';
        adultsObject[`seat_guest_${x}`] = '';
      }

      for (let x = 0; x < children; x++) {
        childrenObject[`age_guest_${x}`] = childrenAges[x];
        childrenObject[`dob_guest_${x}`] = '';
        childrenObject[`seat_guest_${x}`] = '';
      }

      for (let x = 0; x < infants; x++) {
        infantsObject[`age_guest_${x}`] = '';
        infantsObject[`dob_guest_${x}`] = moment(new Date(infantsBirthdays[x])).format('YYYY-MM-DD');
        infantsObject[`seat_guest_${x}`] = 'lap';
      }

      guestInfo.adults = adultsObject;
      guestInfo.children = childrenObject;
      guestInfo.infants = infantsObject;

      this.setState({ guestInfo });
    }
  };

  getContextState = () => {
    return { ...this.state };
  };

  getFields = () => {
    return { ...this.state.fields };
  };

  getGuestInfo = () => {
    return { ...this.state.guestInfo };
  };

  getArrivalAirport = (selectedResort, resortsGateways) => {
    const arrivalGateways = [];

    resortsGateways.forEach((information) => {
      if (information.resortCode.toLowerCase() === selectedResort) {
        const cityName = information.city;
        const gateway = information.gateway;

        arrivalGateways.push({
          label: `${cityName} (${gateway})`,
          value: gateway.toLowerCase(),
        });
      }
    });

    arrivalGateways.sort((gateway1, gateway2) => {
      if (gateway1.value < gateway2.value) {
        return -1;
      }
      if (gateway1.value > gateway2.value) {
        return 1;
      }

      return 0;
    });

    return arrivalGateways;
  };
  _populateGuestInfo = (info) => {
    /* vacationData.guestInfo.item comes from BE as an array but is managed as object on FE */

    const { adults = [], children = [], infants = [] } = info;

    const populatedFields = {
      adults: {},
      children: {},
      infants: {},
    };

    for (let i = 0; i < adults.length; i++) {
      populatedFields.adults[`age_guest_${i}`] = adults[i].age;
      populatedFields.adults[`dob_guest_${i}`] = '';
      populatedFields.adults[`seat_guest_${i}`] = '';
    }

    for (let i = 0; i < children.length; i++) {
      populatedFields.children[`age_guest_${i}`] = children[i].age;
      populatedFields.children[`dob_guest_${i}`] = '';
      populatedFields.children[`seat_guest_${i}`] = '';
    }

    for (let i = 0; i < infants.length; i++) {
      populatedFields.infants[`age_guest_${i}`] = '';
      populatedFields.infants[`dob_guest_${i}`] = infants[i].dob;
      populatedFields.infants[`seat_guest_${i}`] = infants[i].seatType;
    }

    return populatedFields;
  };

  _setInitialGuestInfo = (info = null) => {
    const vacationData = { ...this.state.vacationData };
    const { ...oldFields } = this.state.fields;
    let guestInfo = null;

    if (info) {
      oldFields.adults = vacationData.adults;
      oldFields.children = vacationData.children;
      oldFields.infants = vacationData.infants;

      guestInfo = this._populateGuestInfo(info);
    } else {
      oldFields.adults = 2;
      oldFields.children = 0;
      oldFields.infants = 0;

      guestInfo = {
        adults: {
          age_guest_0: '18',
          dob_guest_0: '',
          seat_guest_0: '',
        },
        children: {},
        infants: {},
      };
    }

    const newFields = { ...oldFields };

    this.setState({ fields: newFields, guestInfo, isLoading: false });
  };

  _resetGuestInfo = () => {
    let showGuestsWarning = null;

    const guestInfo = {
      adults: null,
      children: null,
      infants: null,
    };

    showGuestsWarning = false;

    if (!this.state.hasQQParams) {
      this.setState(() => ({ guestInfo }), () => this._setInitialGuestInfo());
    }

    this.setState({ showGuestsWarning, disableFlights: false });
  };

  _clearAddGuestError = (name, type) => {
    const fieldValidations = { ...this.state.fieldValidations };
    const addGuestErrorDetails = { ...this.state.addGuestErrorDetails };
    let { warning } = this.state;

    // reset error messages
    fieldValidations.addGuestsErrors = true;
    warning = false;

    if (type === 'all') {
      for (const key in addGuestErrorDetails) {
        if (key.includes(name)) {
          delete addGuestErrorDetails[key];
        }
      }
    } else {
      delete addGuestErrorDetails[`${name}_${type}`];
    }

    this.setState({ fieldValidations, addGuestErrorDetails, warning });
  };

  /* I'M SORRY 😬 */
  setGuestCount = (increment, name) => {
    return () => {
      const { maxOccupancy } = this.state;
      const { fields } = this.state;
      const { tempAirIncluded } = this.state;

      const { adults = 2, children = 0, infants = 0 } = this.state.fields;

      const guestCount = new Map();

      guestCount.set('adults', adults);
      guestCount.set('children', children);
      guestCount.set('infants', infants);

      const additionResult = guestCount.get(name) + increment;

      guestCount.set(name, additionResult);

      let totalGuestCount = 0;
      let showGuestsWarning = false;
      let disableFlights = false;
      let isGuestControlOpen = true;

      for (const value of guestCount.values()) {
        totalGuestCount += value;
      }

      const currentCount = this.state.fields[name];
      let newCount = 0;

      newCount = currentCount + increment;

      const validOccupancy = maxOccupancy >= totalGuestCount;

      if (totalGuestCount > 8) {
        showGuestsWarning = tempAirIncluded;
        disableFlights = true;
        fields.airIncluded = false;
        isGuestControlOpen = true;
        this.setState({ isGuestControlOpen });
        validationRules.departure_airport = ['alphaNumeric'];
      } else {
        showGuestsWarning = false;
        disableFlights = false;
        isGuestControlOpen = false;
        tempAirIncluded && !this.state.showFlightWarning
          ? (fields.airIncluded = true)
          : (fields.airIncluded = false);
      }

      if (validOccupancy && newCount > -1) {
        if (name !== 'adults') {
          this.updateFields({ [name]: newCount });
        } else {
          if (name === 'adults' && newCount > 0) {
            this.updateFields({ [name]: newCount });
          }
        }
      }

      if (validOccupancy && name === 'adults') {
        this.setAdultCount(adults, name, increment);
      }

      if (validOccupancy && name === 'children') {
        this.setMinorCount(children, name, increment);
        this._clearAddGuestError('children', 'all');
      }

      if (validOccupancy && name === 'infants') {
        this.setMinorCount(infants, name, increment);
        this._clearAddGuestError('infant', 'all');
      }

      this.setState({ showGuestsWarning, disableFlights, isGuestControlOpen });
    };
  };

  /* Ahi dispensen va! Hice esto a las 12 de la noche */
  /* Ahi lo dispensamos tranqui perrin 🌚*/

  setAdultCount = (adults, name, increment) => {
    const guestType = name;
    const guestIndex = adults;

    if (increment === -1 && adults > 1) {
      this._deleteGuestByType(name, guestIndex);

      return;
    }

    if (guestType === 'adults' && increment === 1) {
      const generateAdults = this._generateAdults(adults);

      this._updateAdults(generateAdults);
    }
  };

  /* creates empty keys and values in guestInfo object for validations */
  setMinorCount = (minors, name, increment) => {
    const minorType = name;
    const minorIndex = minors;

    if (increment === -1) {
      this._deleteGuestByType(name, minorIndex);

      return;
    }

    if (minorType === 'children' && increment) {
      const generateChildren = this._generateChildren(minors);

      this._updateChildren(generateChildren, increment);
    }

    if (minorType === 'infants' && increment) {
      const generateInfants = this._generateInfants(minors);

      this._updateInfants(generateInfants, increment);
    }
  };

  _generateAdults = (adults) => {
    const adultsField = {};

    adultsField[`age_guest_${adults}`] = '16';
    adultsField[`dob_guest_${adults}`] = '';
    adultsField[`seat_guest_${adults}`] = '';

    return adultsField;
  };

  _generateChildren = (children) => {
    const childrenField = {};

    childrenField[`age_guest_${children}`] = '';
    childrenField[`dob_guest_${children}`] = '';
    childrenField[`seat_guest_${children}`] = '';

    return childrenField;
  };

  _generateInfants = (infants) => {
    const infantsField = {};

    infantsField[`age_guest_${infants}`] = '';
    infantsField[`dob_guest_${infants}`] = '';
    infantsField[`seat_guest_${infants}`] = 'lap';

    return infantsField;
  };

  _updateAdults = (newFields) => {
    const { ...oldFields } = this.state.guestInfo;
    const { ...oldAdults } = this.state.guestInfo.adults;

    oldFields.adults = { ...oldAdults, ...newFields };
    const newDates = { ...oldFields };

    this.setState({ guestInfo: newDates });
  };

  /* Children */
  setAge = (value = '', name = '', guestIndex) => {
    this._clearAddGuestError(name, 'children');

    this._updateChildren({
      [name]: value,
      [`dob_guest_${guestIndex}`]: '',
      [`seat_guest_${guestIndex}`]: '',
    });
  };

  _updateChildren = (newFields) => {
    const { ...oldFields } = this.state.guestInfo;
    const { ...oldChildren } = this.state.guestInfo.children;

    oldFields.children = { ...oldChildren, ...newFields };

    const newDates = { ...oldFields };

    this.setState({ guestInfo: newDates });
  };

  _deleteGuestByType = (guestType, guestIndex) => {
    const { ...oldFields } = this.state.guestInfo;
    const { ...oldGuestType } = this.state.guestInfo[guestType];

    delete oldGuestType[`age_guest_${guestIndex - 1}`];
    delete oldGuestType[`dob_guest_${guestIndex - 1}`];
    delete oldGuestType[`seat_guest_${guestIndex - 1}`];

    oldFields[guestType] = oldGuestType;

    const newFields = { ...oldFields };

    this.setState({ guestInfo: newFields });
  };

  /* Infants */
  setSeatType = (value = '', name = '') => {
    this._updateInfants({ [name]: value });
    this._clearAddGuestError(name, 'infant');
  };

  setDateOfBirth = (value = '', name = '', guestIndex) => {
    this._clearAddGuestError(name, 'infant');

    this._updateInfants({
      [name]: value,
      [`age_guest_${guestIndex}`]: '',
    });
  };

  _updateInfants = (newFields) => {
    const { ...oldFields } = this.state.guestInfo;
    const { ...oldInfants } = this.state.guestInfo.infants;

    oldFields.infants = { ...oldInfants, ...newFields };
    const newDates = { ...oldFields };

    this.setState({ guestInfo: newDates });
  };
  /* fin de metodos para addGuests */

  _setMaxOccupancy = (rstCode = 'BTC') => {
    const { adults, children, infants } = this.state.fields;
    const totalGuests = adults + children + infants;

    const resorts = _app.results.resorts;

    const maxOccupancyObj = {};
    let resortMaxOccupancy = 0;

    if (rstCode !== '') {
      for (const item of resorts) {
        maxOccupancyObj[item.rstCode] = {
          maxOccupancy: item.maxOccupancy,
        };
      }

      resortMaxOccupancy = maxOccupancyObj[rstCode.toUpperCase()].maxOccupancy;

      if (totalGuests > resortMaxOccupancy) {
        this._resetGuestInfo();
      }

      this.setState({ maxOccupancy: resortMaxOccupancy });
    }
  };

  setInputValue = (value = '', name = '', resortGateways = []) => {
    const groupResponse = { ...this.state.groupResponse };
    const promoCodeResponse = { ...this.state.promoCodeResponse };
    const fieldValidation = validationEngine.runValidations(
      validationRules,
      value,
      name
    );

    if (name === 'groupCode') {
      groupResponse.code = -1;
      this.setState({ groupResponse });
    }

    if (!window._app.brandOptions.isSandals && name === 'rstCode') {
      this._setMaxOccupancy(value);
    }

    if (name === 'rstCode') {
      const rstCode = value;
      const rstGateways = this.getArrivalAirport(rstCode, resortGateways);
      const fields = this.state.fields;

      if (rstGateways.length > 0) {
        fields.arrivalGateway = rstGateways[0].value.toLowerCase();
        this.setState({ fields });
      }
    }

    if (name === 'promoCode') {
      promoCodeResponse.code = -1;
      promoCodeResponse.message = '';

      this.setState({ promoCodeResponse });

      if (value === '') {
        // validationRules.prn = ['beEmail'];

        this._updateFieldValidations({
          [name]: fieldValidation.allValid,
          prn: true,
        });
      }
    } else {
      this._updateFieldValidations({ [name]: fieldValidation.allValid });
    }

    if (name === 'airIncluded') {
      this.setState({ tempAirIncluded: value });

      if (!value) {
        validationRules.departure_airport = ['alphaNumeric'];
      }
    }
    this.updateFields({ [name]: value });
  };

  setDefaultValuesValidation = () => {
    const fieldsRules = validationRules;
    const namedFields = Object.keys(fieldsRules);
    let fieldValidations = { ...this.state.fieldValidations };

    fieldValidations = {};

    namedFields.map((field) => {
      fieldValidations[field] = true;
    });

    // flag for add guest in beaches and gp OBE
    fieldValidations.addGuestsErrors = true;

    this.setState({ fieldValidations });
  };

  toggleRequired = (fieldNameArray = []) => {
    const required = 'required';

    return () => {
      fieldNameArray.map((fieldName) => {
        const [...validationArray] = validationRules[fieldName];
        const indexOfRequired = validationArray.indexOf(required);

        if (indexOfRequired > -1) {
          validationArray.splice(indexOfRequired, 1);
        } else {
          validationArray.push(required);
        }

        validationRules[fieldName] = validationArray;
      });
    };
  };

  toggleLoader = (value) => {
    this.setState({ showLoader: value });
  };

  _toggleRecoveryModal = (name) => {
    return () => {
      let { isPassword } = this.state;

      // validation used for change modal content
      if (name === 'username') {
        isPassword = false;
      } else {
        isPassword = true;
      }

      this.toggleRequired(['username_recovery', 'email_recovery'])();

      this.setState({ isPassword });
    };
  };

  trySubmit = (inputNames, fields, type = 'custom') => {
    const fieldValidations = { ...this.state.fieldValidations };
    let { warning } = this.state;
    let fieldsErrors = 0;

    // Re run validations to be sure that everything is ok.
    const invalidFields = inputNames
      .map((inputName) => {
        const inputValue =
          typeof fields[inputName] === undefined ? '' : fields[inputName];
        const fieldValidation = validationEngine.runValidations(
          validationRules,
          inputValue,
          inputName
        );
        const ruleOptions = fieldValidation.validationsObject[inputName] || {};

        const getErrors = (rules) =>
          Object.keys(rules).reduce(
            (result, ruleName) => ruleOptions[ruleName].message || '',
            ''
          );

        this._updateFieldValidations({ [inputName]: fieldValidation.allValid });

        // Setting up styles in invalid fields and error counting.

        if (fieldValidation.allValid === false) {
          if (fieldsErrors === 0 && type === 'custom') {
            warning = true;
            this._onErrorScroll();
          }

          fieldsErrors++;
          fieldValidations[inputName] = false;

          return {
            [inputName]: {
              value: fields[inputName],
              error: getErrors(ruleOptions),
            },
          };
        }

        return {};
      })
      .reduce(
        (result, errorField) => Object.assign({}, result, errorField),
        {}
      );

    // validating additional guest modal for beaches and gp
    const addGuestsErrors = this.validateAddGuests();

    if (addGuestsErrors > 0 && type === 'custom') {
      fieldValidations.addGuestsErrors = false;
      fieldsErrors++;
      warning = true;
      this._onErrorScroll();
    }

    // Seding the user's errors to Splunk
    if (Object.keys(invalidFields).length > 0) {
      DataService.logFE({
        payload: JSON.stringify(invalidFields),
        uri: window.location.pathname,
        step: window._app.page.step,
      });
    }

    this.setState({ fieldValidations, warning });

    return fieldsErrors;
  };

  validateAddGuests = () => {
    // const fields = {...this.state.fields};
    const guestInfo = { ...this.state.guestInfo };
    const childrenFields = Object.keys(guestInfo.children);
    const infantsFields = Object.keys(guestInfo.infants);
    let noOfInvalids = 0;
    const addGuestErrorDetails = { ...this.state.addGuestErrorDetails };
    const infantsRegex = /seat|dob/g;

    childrenFields.map((field) => {
      if (field.includes('age') && guestInfo.children[field] === '') {
        noOfInvalids++;
        addGuestErrorDetails[`${field}_children`] = false;
      }
    });

    infantsFields.map((field) => {
      if (guestInfo.infants[field] === '' && infantsRegex.test(field)) {
        noOfInvalids++;
        addGuestErrorDetails[`${field}_infant`] = false;
      }
    });

    this.setState({ addGuestErrorDetails });

    return noOfInvalids;
  };

  _onErrorScroll = () => {
    const topPosition = 100;
    const scrollOffset = window.pageYOffset;

    window.scrollTo({
      top: topPosition - scrollOffset,
      behavior: 'smooth',
    });
  };

  logoutSSG = async() => {
    this.toggleLoader(true);

    const ssgResponse = await DataService.logoutSSG();
    const { showRecaptcha } = this.state;

    validationRules.username = ['ssgUsername'];
    validationRules.password = [];

    if (showRecaptcha) {
      validationRules.recaptchaToken = [];
    }

    this.setState({ ssgResponse });
    this.toggleLoader(false);

    if (ssgResponse.message === 'success') {
      this.setState({ hasSSG: false });
    }
  };

  submitPromoCode = async(signedIn = 0, email = '', promoCode = '') => {
    /*
    * LTT
      - promoCode
      - email

      OTHERS
      - promoCode
      - checkInDate
      - rstCode
    */

    const fields = {};
    const { promoCode: isValidCode } = this.state.fieldValidations;
    const inputNames = ['promoCode'];
    const isLoyaltyPromo = promoCode.toUpperCase().startsWith('LTT');

    // Building Fields Object
    fields.promoCode = promoCode;

    if (signedIn !== 1 && isLoyaltyPromo) {
      fields.prn = email;
      validationRules.prn = ['required'];
      inputNames.push('prn');
    } else if (!isLoyaltyPromo) {
      fields.rstCode = this.state.fields.rstCode;
      fields.checkInDate = this.state.fields.checkInDate;
      fields.checkOutDate = this.state.fields.checkOutDate;
      inputNames.push('rstCode', 'checkInDate', 'checkOutDate');
    }

    const noErrors = this.trySubmit(inputNames, fields, 'promo');

    if (noErrors > 0 && !isLoyaltyPromo && isValidCode) {
      this._onErrorScroll();
    }

    if (noErrors === 0) {
      this.toggleLoader(true);

      const endPointFields = { ...fields };

      // unnecesary extra check
      if (endPointFields.prn) {
        endPointFields.email = fields.prn;
        delete endPointFields.prn;
      }

      const promoCodeResponse = await DataService.submitPromoCode(
        endPointFields
      );

      this.setState({ promoCodeResponse });

      this.toggleLoader(false);
    }
  };

  setSSGState = (name = '', value = '') => {
    const ssgCredentials = { ...this.state.ssgCredentials };
    const ssgResponse = { ...this.state.ssgResponse };
    const fieldValidation = validationEngine.runValidations(
      validationRules,
      value,
      name
    );
    let { warning } = this.state;

    ssgResponse.message = '';
    ssgResponse.code = -1;
    ssgCredentials[name] = value;
    warning = false;

    this._updateFieldValidations({ [name]: fieldValidation.allValid });
    this.updateCredentials(ssgCredentials);
    this.setState({ ssgResponse, warning });
  };

  setSSGRecoveryState = (value = '') => {
    this.setState({ recaptchaToken: value });
  };

  clearSSGState = () => {
    const fieldValidations = { ...this.state.fieldValidations };
    const ssgCredentials = { ...this.state.ssgCredentials };
    const ssgResponse = { ...this.state.ssgResponse };
    const inputNames = Object.keys(ssgCredentials);
    let { warning } = this.state;

    ssgCredentials.username = '';
    ssgCredentials.password = '';
    ssgCredentials.recaptchaToken = '';
    ssgResponse.message = '';
    ssgResponse.code = -1;
    warning = false;

    inputNames.map((field) => {
      fieldValidations[field] = true;
    });

    this.updateCredentials(ssgCredentials);
    this.setState({ ssgResponse, fieldValidations, warning });
  };

  submitSSG = async() => {
    const ssgCredentials = { ...this.state.ssgCredentials };
    const inputNames = Object.keys(ssgCredentials);
    const noErrors = this.trySubmit(inputNames, ssgCredentials, 'login');
    let { submitSSGAttemps, showRecaptcha } = this.state;

    if (noErrors === 0) {
      this.toggleLoader(true);

      const ssgResponse = await DataService.saveSSG(this.state.ssgCredentials);

      submitSSGAttemps++;

      if (submitSSGAttemps === 5) {
        showRecaptcha = true;
        this.toggleRequired(['recaptchaToken'])();
      }

      this.setState({ ssgResponse, submitSSGAttemps, showRecaptcha });
      this.toggleLoader(false);

      // cleaning ssg credentials after success.
      if (ssgResponse.code === 1) {
        this.setState({ hasSSG: true });

        this.cleanSSGCredentials(ssgCredentials, inputNames);

        validationRules.prn = ['beEmail'];
      } else if (ssgResponse.code !== 1 && showRecaptcha) {
        this.recaptchaRef.current.reset();

        this.cleanSSGCredentials(ssgCredentials, ['recaptchaToken']);

        validationRules.recaptchaToken = ['required'];
      } else if (ssgResponse.code !== 1) {
        const { data, status } = ssgResponse.content.data;

        if (status === 'invalid' && data.result === 'redirectAccounts') {
          window.location = 'https://sandalsselect.com/new-password/'; // `${urlBase}forgot-password?isInvalid`;
        }
      }
    }
  };

  cleanSSGCredentials = (ssgCredentials, inputNames) => {
    inputNames.map((field) => {
      ssgCredentials[field] = '';
    });

    this.setState({ ssgCredentials });
  };

  setRecoveryValue = (value, name) => {
    const fieldValidation = validationEngine.runValidations(
      validationRules,
      value,
      name
    );
    const recoverySSGCredentials = { ...this.state.recoverySSGCredentials };
    const recoverySSGResponse = { ...this.state.recoverySSGResponse };

    recoverySSGCredentials[name] = value;
    recoverySSGResponse.code = -1;

    this._updateFieldValidations({ [name]: fieldValidation.allValid });
    this.setState({ recoverySSGCredentials, recoverySSGResponse });
  };

  submitSSGRecovery = async(isPassword) => {
    const recoverySSGCredentials = this.state.recoverySSGCredentials;
    let recaptchaToken = this.state.recaptchaToken;
    const inputNames = Object.keys(recoverySSGCredentials);
    let {
      recoveryUserSSGAttemps,
      recoveryPasswordSSGAttemps,
      showRecoveryUserRecaptcha,
      showRecoveryPasswordRecaptcha,
    } = this.state;
    let params = {};
    let fields = {};
    let noErrors = 0;
    let method = '';

    if (isPassword) {
      params = {
        email: recoverySSGCredentials.email_recovery,
        username: recoverySSGCredentials.username_recovery,
        recaptchaToken: showRecoveryPasswordRecaptcha ? recaptchaToken : '',
      };
      method = 'ssgPasswordRecovery';
      fields = {
        email_recovery: recoverySSGCredentials.email_recovery,
        username_recovery: recoverySSGCredentials.username_recovery,
      };
    } else {
      params = {
        email: recoverySSGCredentials.email_recovery,
        recaptchaToken: showRecoveryUserRecaptcha ? recaptchaToken : '',
      };
      method = 'ssgUserRecovery';
      fields = {
        email_recovery: recoverySSGCredentials.email_recovery,
        username_recovery: recoverySSGCredentials.email_recovery,
      };
    }

    noErrors = this.trySubmit(inputNames, fields, 'recovery');

    if (noErrors === 0) {
      this.toggleLoader(true);
      const recoverySSGResponse = await DataService[method](params);

      // cleaning state after success. [this code was commented in 23/09/2022]
      // if (recoverySSGResponse.code === 1) {
      //   inputNames.map(field => { recoverySSGCredentials[field] = ''; });
      // }
      if (
        showRecoveryPasswordRecaptcha &&
        method === 'ssgPasswordRecovery' &&
        recoverySSGResponse !== 0
      ) {
        this.recoveryPasswordRecaptchaRef.current.reset();
        recaptchaToken = '';
      }
      if (
        showRecoveryUserRecaptcha &&
        method === 'ssgUserRecovery' &&
        recoverySSGResponse !== 0
      ) {
        this.recoveryUserRecaptchaRef.current.reset();
        recaptchaToken = '';
      }
      if (method === 'ssgPasswordRecovery') {
        recoveryPasswordSSGAttemps++;
      } else {
        recoveryUserSSGAttemps++;
      }

      if (recoveryPasswordSSGAttemps === 5) {
        showRecoveryPasswordRecaptcha = true;
      }
      if (recoveryUserSSGAttemps === 5) {
        showRecoveryUserRecaptcha = true;
      }

      this.setState({
        recoverySSGCredentials,
        recoverySSGResponse,
        recoveryUserSSGAttemps,
        recoveryPasswordSSGAttemps,
        showRecoveryUserRecaptcha,
        showRecoveryPasswordRecaptcha,
        recaptchaToken,
      });
      this.toggleLoader(false);
    }
  };

  submitGroup = async() => {
    // fields object declaration is different here because we only have one field.
    const groupCodeFields = {};

    groupCodeFields.groupCode = this.state.fields.groupCode;

    const inputNames = Object.keys(groupCodeFields);
    const noErrors = this.trySubmit(inputNames, groupCodeFields, 'group');

    if (noErrors === 0) {
      this.toggleLoader(true);
      const groupResponse = await DataService.saveGroup(
        this.state.fields.groupCode
      );

      this.setState({ groupResponse });
      this.toggleLoader(false);
    }
  };

  removeGroup = async() => {
    this.toggleLoader(true);
    const removeGroupResponse = await DataService.removeGroup();

    if (removeGroupResponse.code === 1) {
      this.setState({ removeGroupResponse, hasGroup: false });
    }

    this.toggleLoader(false);
  };

  submitVacation = () => {
    const ssgCredentials = { ...this.state.ssgCredentials };
    const ssgResponse = { ...this.state.ssgResponse };
    const fields = { ...this.state.fields };
    let allFields = {};

    // 1 means log in. If exist, validator will not run for these fields.
    if (ssgResponse.code === 1) {
      allFields = { ...fields };
    } else {
      allFields = { ...ssgCredentials, ...fields };
    }
    // const { rstCode: aResortCode } = allFields;

    // if (
    //   aResortCode.toLowerCase() === 'sbd' ||
    //   aResortCode.toLowerCase() === 'sbd' ||
    //   aResortCode.toLowerCase() === 'sls'
    // ) {
    //   allFields.rstCode = '';
    // }

    const inputNames = Object.keys(allFields);
    let noErrors = this.trySubmit(inputNames, allFields);
    // custom validation for business rules (nights <= 21)
    const { checkInDate, checkOutDate } = fields;
    const startDate = moment(checkInDate);
    const endDate = moment(checkOutDate);
    const nights = endDate.diff(startDate, 'days');

    if (nights > 21 || nights < 3) {
      noErrors++;
      this._onErrorScroll('checkInDate');
      this.activeDatesWarningMessage(true);
    } else {
      this.activeDatesWarningMessage(false);
    }

    return noErrors;
  };

  activeDatesWarningMessage = (active) => {
    this.setState({ showLessThan3NightsWarning: active });
  };

  setGuestType = (checkInDate, checkOutDate, dob) => {
    const dateOfBirth = moment(dob, 'YYYY-MM-DD');
    const age = moment(checkOutDate, 'YYYY-MM-DD').diff(dateOfBirth, 'years');
    let type = null;

    switch (true) {
      case age < 2:
        type = 'i';
        break;
      case age >= 2 && age < 16:
        type = 'c';
        break;
      case age >= 16:
        type = 'a';
        break;
      default:
        type = 'a';
        break;
    }

    return { type, age };
  };

  buidGuestTypeInfo = (
    type = 'a',
    adultsObject,
    childrenObject,
    infantsObject,
    index,
    guest,
    birthYear
  ) => {
    switch (type) {
      case 'a':
        adultsObject[`age_guest_${index}`] =
          guest.age ||
          moment(`01-01-${birthYear}`).diff(
            this.state.fields.checkOutDate,
            'years'
          ) ||
          18;
        adultsObject[`dob_guest_${index}`] = '';
        adultsObject[`seat_guest_${index}`] = '';
        break;
      case 'c':
        childrenObject[`age_guest_${index}`] = guest.age || 2;
        childrenObject[`dob_guest_${index}`] = '';
        childrenObject[`seat_guest_${index}`] = '';
        break;
      case 'i':
        infantsObject[`age_guest_${index}`] = '';
        infantsObject[`dob_guest_${index}`] = guest.dob;
        infantsObject[`seat_guest_${index}`] = guest.seatType || 'lap';
        break;
      default:
        adultsObject[`age_guest_${index}`] = 18;
        adultsObject[`dob_guest_${index}`] = '';
        adultsObject[`seat_guest_${index}`] = '';
        break;
    }
  };

  updateGuestInfo = () => {
    const { guestInfo } = this.state;
    const fields = { ...this.state.fields };
    const infantFields = Object.keys(guestInfo.infants);
    const childrenFields = Object.keys(guestInfo.children);
    const adultFields = Object.keys(guestInfo.adults);
    const birthdaysArray = [];
    const adultsObject = {};
    const childrenObject = {};
    const infantsObject = {};
    let newGuestInfo = {};
    let adults = 0;
    let children = 0;
    let infants = 0;

    const newInfantObject = {};

    for (let x = 0; x < fields.adults; x++) {
      const newAdultsObject = {};

      adultFields.map((field) => {
        if (field.includes(x)) {
          if (field.includes('dob')) {
            newAdultsObject.dob = guestInfo.adults[field];
          } else if (field.includes('age')) {
            newAdultsObject.age = guestInfo.adults[field];
          } else {
            newAdultsObject[field] = guestInfo.adults[field];
          }
        }
      });

      birthdaysArray.push({ ...newAdultsObject });
    }

    for (let x = 0; x < fields.children; x++) {
      const newChildrenObject = {};

      childrenFields.map((field) => {
        if (field.includes(x)) {
          if (field.includes('dob')) {
            newChildrenObject.dob = guestInfo.children[field];
          } else if (field.includes('age')) {
            newChildrenObject.age = guestInfo.children[field];
          } else {
            newChildrenObject[field] = guestInfo.children[field];
          }
        }
      });

      birthdaysArray.push({ ...newChildrenObject });
    }

    for (let x = 0; x < fields.infants; x++) {
      infantFields.map((field) => {
        if (field.includes(x)) {
          if (field.includes('dob')) {
            newInfantObject.dob = guestInfo.infants[field];
          } else if (field.includes('age')) {
            newInfantObject.age = guestInfo.infants[field];
          } else {
            newInfantObject[field] = guestInfo.infants[field];
          }
        }
      });

      birthdaysArray.push({ ...newInfantObject });
    }

    birthdaysArray.map((guest) => {
      const maxYear = moment(fields.checkOutDate).year();
      const birthYear = maxYear - guest.age;
      const { type } = this.setGuestType(
        fields.checkInDate,
        fields.checkOutDate,
        guest.dob || `${birthYear}-MM-DD`
      );

      if (type === 'i') {
        this.buidGuestTypeInfo(
          'i',
          adultsObject,
          childrenObject,
          infantsObject,
          infants,
          guest,
          birthYear
        );

        infants++;
      } else if (type === 'c') {
        this.buidGuestTypeInfo(
          'c',
          adultsObject,
          childrenObject,
          infantsObject,
          children,
          guest,
          birthYear
        );

        children++;
      } else if (type === 'a') {
        this.buidGuestTypeInfo(
          'a',
          adultsObject,
          childrenObject,
          infantsObject,
          adults,
          guest,
          birthYear
        );

        adults++;
      }
    });

    fields.adults = adults;
    fields.children = children;
    fields.infants = infants;

    newGuestInfo = {
      adults: adultsObject,
      children: childrenObject,
      infants: infantsObject,
    };

    // this.setState({ fields, guestInfo: newGuestInfo });
    this.updateGuestCount(fields, newGuestInfo);
  };

  updateGuestCount = async(fields, guestInfo) => {
    this.toggleLoader(true);

    const step1 = await DataService.processVacation(fields, guestInfo);

    if (step1.code === 1) {
      if (storage.get('salesConversion').code === 1) {
        storage.clearObj('salesConversion');
      }
      window.location.href = `/room/?subSessionId=${encodeURIComponent(
        window._app.page.subSessionId
      )}`;

      return;
    }

    this.toggleLoader(false);
  };

  updateCount = (newFields) => {
    const { ...oldFields } = this.state.fields;
    const fields = { ...oldFields, ...newFields };

    this.setState({ fields });
  };

  updateFields = (newFields) => {
    const { ...oldFields } = this.state.fields;
    const fields = { ...oldFields, ...newFields };
    let { warning } = this.state;

    warning = false;

    this.setState({ fields, warning });
  };

  _updateFieldValidations = (newFields) => {
    const { ...oldFields } = this.state.fieldValidations;
    const fieldValidations = { ...oldFields, ...newFields };

    this.setState({ fieldValidations });
  };

  updateCredentials = (newCredentials) => {
    const { ...oldCredentials } = this.state.ssgCredentials;
    const ssgCredentials = { ...oldCredentials, ...newCredentials };

    this.setState({ ssgCredentials });
  };

  setMultipleInputValues = (values = [], names = []) => {
    const fieldValidations = { ...this.state.fieldValidations };
    const newFields = {};

    names.map((name, index) => {
      newFields[name] = values[index];
      fieldValidations[name] = true;
    });

    this.setState({ fieldValidations });
    this.updateFields(newFields);
  };

  checkAirAvailability({ startDate, endDate }) {
    const allPartiesAvailable = startDate && endDate;
    const maxFlightDate = moment().add(329, 'days');
    const minFlightDate = moment().add(14, 'days');
    const showFlightWarning = allPartiesAvailable && ((endDate > maxFlightDate) || (startDate < minFlightDate));

    return showFlightWarning;
  }

  _checkInfantsDOB = (startDate, endDate) => {
    // const maxDate = endDate ? endDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    // const minDate = endDate ? endDate.subtract(2, 'years').add(1, 'days').format('YYYY-MM-DD') : moment().subtract(2, 'years').format('YYYY-MM-DD');
    const guestInfo = { ...this.state.guestInfo };
    const infantFields = Object.keys(guestInfo.infants);

    infantFields.map((field) => {
      if (field.includes('dob') && endDate) {
        // const isValidDate = this._isDateInRange(guestInfo.infants[field], minDate, maxDate);

        // https://sanserviceshn.atlassian.net/browse/SOBE-1412 leave validation to be done by Backend
        const isValidDate = true;

        if (!isValidDate) {
          guestInfo.infants[field] = '';
        }
      }
    });

    this.setState({ guestInfo });
  };

  _isDateInRange = (currentDate, minRange, maxRange) => {
    return moment(currentDate).isBetween(moment(minRange), moment(maxRange));
  };

  onDateChange = ({ startDate: rawStartDate, endDate: rawEndDate }) => {
    const startDate =
      rawStartDate && moment(rawStartDate._d).format(constants.DB_DATE_FORMAT);
    const endDate =
      rawEndDate && moment(rawEndDate._d).format(constants.DB_DATE_FORMAT);
    const fieldValidations = { ...this.state.fieldValidations };
    const fields = { ...this.state.fields };

    const showFlightWarning = this.checkAirAvailability({
      startDate: rawStartDate,
      endDate: rawEndDate,
    });

    const dateValidation = validationEngine.runValidations(
      validationRules,
      [startDate, endDate],
      ['checkInDate', 'checkOutDate']
    );

    fieldValidations.checkInDate = dateValidation.allValid;
    fieldValidations.checkOutDate = dateValidation.allValid;

    fields.checkInDate = startDate;
    fields.checkOutDate = endDate;

    const showLessThan3NightsWarning = false;

    if (showFlightWarning) {
      fields.airIncluded = false;
      validationRules.departure_airport = ['alphaNumeric'];
    }

    this.setState(
      {
        fieldValidations,
        fields,
        showFlightWarning,
        showLessThan3NightsWarning,
      },
      () => {
        this._checkInfantsDOB(rawStartDate, rawEndDate);
      }
    );
  };

  _resetSSGModal = () => {
    const fieldValidations = { ...this.state.fieldValidations };
    const recoverySSGCredentials = { ...this.state.recoverySSGCredentials };
    const recoverySSGResponse = { ...this.state.recoverySSGCredentials };

    fieldValidations.username_recovery = true;
    fieldValidations.email_recovery = true;
    recoverySSGResponse.code = -1;
    recoverySSGCredentials.username_recovery = '';
    recoverySSGCredentials.email_recovery = '';

    this.setState({
      fieldValidations,
      recoverySSGCredentials,
      recoverySSGResponse,
    });
  };

  openModal = (name, type = '', e = null) => {
    const currentState = { ...this.state.isModalOpen };

    e && e.preventDefault();
    currentState[name] = true;

    if (name === 'forgotPassword') {
      this._toggleRecoveryModal(type)();
    }

    this.setState({ isModalOpen: currentState });
  };

  closeModal = (name) => {
    return () => {
      const currentState = { ...this.state.isModalOpen };

      currentState[name] = false;

      if (name === 'forgotPassword') {
        this._resetSSGModal();
        this.toggleRequired(['username_recovery', 'email_recovery'])();
      }

      this.setState({ isModalOpen: currentState });
    };
  };

  // ssgResponse and groupResponse are hard-coded responses for testing while developing.
  // Use these when trying to simulate different scenarios for responses from the server.
  // Use context.state.ssgResponse and context.state.ssgResponse to work with real data.
  render() {
    const context = {
      state: this.state,
      getFields: this.getFields,
      getGuestInfo: this.getGuestInfo,
      setRecoveryValue: this.setRecoveryValue,
      setGuestCount: this.setGuestCount,
      checkGuestsAvailability: this.checkGuestsAvailability,
      setAge: this.setAge,
      setSeatType: this.setSeatType,
      setDateOfBirth: this.setDateOfBirth,
      toggleRequired: this.toggleRequired,
      toggleLoader: this.toggleLoader,
      setVacationResponse: this.setVacationResponse,
      cleanVacationResponse: this.cleanVacationResponse,
      submitSSG: this.submitSSG,
      submitSSGRecovery: this.submitSSGRecovery,
      submitGroup: this.submitGroup,
      removeGroup: this.removeGroup,
      submitVacation: this.submitVacation,
      updateGuestInfo: this.updateGuestInfo,
      onDateChange: this.onDateChange,
      getArrivalAirport: this.getArrivalAirport,
      submitPromoCode: this.submitPromoCode,
      setSSGState: this.setSSGState,
      setSSGRecoveryState: this.setSSGRecoveryState,
      clearSSGState: this.clearSSGState,
      logoutSSG: this.logoutSSG,
      setInputValue: this.setInputValue,
      setMultipleInputValues: this.setMultipleInputValues,
      isModalOpen: this.isModalOpen,
      openModal: this.openModal,
      closeModal: this.closeModal,
      recaptchaRef: this.recaptchaRef,
      recoveryUserRecaptchaRef: this.recoveryUserRecaptchaRef,
      recoveryPasswordRecaptchaRef: this.recoveryPasswordRecaptchaRef,
      activeDatesWarningMessage: this.activeDatesWarningMessage,
      validationRules: validationRules,
      groupResponse: {
        code: -1,
        content: {},
      },
    };

    return (
      <VacationContext.Provider value={context}>
        {this.props.children}
      </VacationContext.Provider>
    );
  }
}

export { VacationContext, VacationProvider };



// WEBPACK FOOTER //
// ./js/components/step1/VacationContext.js